import { setExtractFileTextErrorModal } from '../../../../../store/workspace/slice';
import { ResetSquareIcon } from '../../../../../assets/icons';
import { useDispatch } from '../../../../../store/store';
import Modal from '../../../../../components/Modal'
import styles from './style.module.scss';

export default function ExtractFileTextError() {
    const dispatch = useDispatch();

    return (
        <Modal
            size='md'
            title='Extract file error'
            icon={<ResetSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setExtractFileTextErrorModal(false))}
            actions='dismiss'
            restrictActionsWidth
            dismissButton={{
                text: 'Close',
                type: 'Outline-Primary',
                onClick: () => dispatch(setExtractFileTextErrorModal(false)),
            }}
        >
            <p>
                The file might be locked or empty. Unable to extract text.
            </p>
        </Modal>
    )
}
